import { initialState } from '../schema';

export const reduceClearAllErrors = () => initialState;
